import { MutableRefObject, useEffect } from 'react';

const useOutsideClick = (
  ref: MutableRefObject<HTMLElement | null>,
  callback: () => void,
  parentRootId?: string,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if click is inside modal
      const modalRoot = document.getElementById('modal-root');
      if (modalRoot && modalRoot.contains(event.target as Node)) {
        return; // Don't trigger callback if click is inside modal
      }

      // Check if click is inside the ref element
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, parentRootId]);
};

export default useOutsideClick;
